import { useEffect, useState } from 'react';

import { EnumOption } from '../../../modules/types/types';
import httpClient from '../../httpClient';

export const useTipoDocumentoMedsus = () => {
  const [registroEnum, setRegistroEnum] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchRegistroEnum = async () => {
      try {
        const response = await httpClient.get(
          `/api/medsusdocumento/tipodocumento`,
        );
        const options = response.data.map(
          (registro: { value: number; label: string }) => ({
            value: registro.value.toString(),
            label: registro.label,
          }),
        );
        setRegistroEnum(options);
      } catch (error) {
        console.error('Erro ao buscar Tipos de Documentos MedSUS.', error);
      }
    };

    fetchRegistroEnum();
  }, []);

  return registroEnum;
};
